// extracted by mini-css-extract-plugin
module.exports = {"DateRange":"styles_DateRange__3UFeJ","Calendar":"styles_Calendar__3kBUZ"};